<script>
    export let displayMenu;
    export let onOpenMenu;
    export let onCloseMenu;
    function onMenuClick(e) {
        displayMenu ? onCloseMenu(e) : onOpenMenu(e);
    }
</script>

<div id="nav-bar">
    <a href="/">
        <img class="logo" src="/images/logo.svg" role="presentation" alt="" />
    </a>
    <h1>Brodie Hamilton</h1>
    <div>
        <div class={"menu" + (displayMenu ? " open" : "")}  on:click={onMenuClick}></div>
    </div>
</div>

<style>
    #nav-bar {
        margin: auto;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    #nav-bar h1 {
        margin: 0 60px 0 0;
    }
    .logo {
        vertical-align: middle;
    }
    .menu {
        cursor: pointer;
        height: 60px;
        width: 60px;
        position: fixed;
        top: 20px;
        right: 10px;
        border: 10px solid transparent;
        z-index: 1;
        background-color: #fff5e6;
        border-radius: 10px;

        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-image: url(/images/menu.svg);

        -webkit-transition: background-image 1s ease-in-out;
        -moz-transition: background-image 1s ease-in-out;
        transition: background-image 1s ease-in-out;

        -webkit-transition: background-color 0.25s ease-in-out 0.5s;
        -moz-transition: background-color 0.25s ease-in-out 0.5s;
        transition: background-color 0.25s ease-in-out 0.5s;
    }
    .menu.open {
        background-image: url(/images/menu-close.svg);
        background-color: transparent;

        -webkit-transition: background-color 0s ease-in-out;
        -moz-transition: background-color 0s ease-in-out;
        transition: background-color 0s ease-in-out;
    }
</style>